var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerfluid"},[_c('apexchart',{key:_vm.chartdata,attrs:{"height":"200","options":_vm.ApexChartOptions,"series":_vm.ApexChartOptions.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }